import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { useTherapeuticCategoriesAccess } from 'App/utils/hooks/useIsPermitted';
import { NotFound } from '../errors';
import Main from '../styles/Main/Main';
import CategoryListPage from './CategoryListPage';
import CreateCategoryPage from './CreateCategoryPage';
import EditCategoryPage from './EditCategoryPage';

const propTypes = {};

const defaultProps = {};

function TherapeuticCategoryRouter() {
    //#region State
    const hasTcPageAccess = useTherapeuticCategoriesAccess();
    //#endregion

    if (hasTcPageAccess) {
        return (
            <Main>
                <Routes>
                    <Route path="/create" element={<CreateCategoryPage />} />

                    <Route path="/:therapyId" element={<EditCategoryPage />} />

                    <Route index element={<CategoryListPage />} />
                </Routes>
            </Main>
        );
    }

    return <NotFound />;
}

TherapeuticCategoryRouter.propTypes = propTypes;
TherapeuticCategoryRouter.defaultProps = defaultProps;

export default TherapeuticCategoryRouter;
